import type { BeautifulObjectId } from '@stellar-globe/stellar-globe'

export const prettyPictureTitles: Record<BeautifulObjectId, string> = {
  m31: 'M31',
  m42: 'M42',
  m45: 'M45',
  m101: 'M101',
  perseus: 'Perseus Cluster',
}

// 一列だけを RGB の全成分へ割り当てる。
export function selectMixColumn(mix: number[], column: number, nFilters: number): number[] {
  const next = [...mix]
  for (let j = 0; j < nFilters; j++) {
    for (let i = 0; i < 3; i++) {
      next[j * 3 + i] = j === column ? 1 : 0
    }
  }
  return next
}
